module.exports = __webpack_public_path__ + "media/reskin-images/icon--user-circle-fc738421.svg";